import { isTestMode } from './utilityFunctions';
import { container } from '../../utils/container/container';
import { ServiceIds } from '../../utils/container/service-ids';
import { GlobalAppConfig } from '../../types/windowPatching';

export function getUserSuid(notRealSuid?: boolean) {
    const config = container.get<GlobalAppConfig>(ServiceIds.CONFIG);
    if (isTestMode() && notRealSuid) {
        if (config.suid_simulate) {
            return config.suid_simulate;
        }
    }

    return config.suid;
}
